// IMPORT
import React from "react";

// CSS
import './TeaserSectors.css'

// Images
import ImgSector1 from '../../pages/global/images/Bakery.jpg'
import ImgSector2 from '../../pages/global/images/Gastromomie.png'
import ImgSector3 from '../../pages/global/images/Gesundheitswesen.png'
import ImgSector4 from '../../pages/global/images/Großhandel.jpg'
import ImgSector5 from '../../pages/global/images/Apotheke.png'
import ImgSector6 from '../../pages/global/images/Lebensmittelproduzenten.png'
import ImgSector7 from '../../pages/global/images/LEH.png'
import ImgSector8 from '../../pages/global/images/Maschinen_und_Anlagenbau.png'
import ImgSector9 from '../../pages/global/images/Postdienstleister.png'
import ImgSector10 from '../../pages/global/images/Transportlogistik.png'
import ImgSector11 from '../../pages/global/images/Workwear.png'

// Components
import CompHeadingText from "../CompHeadingText";
import CompPictureTextBottom from "../CompPictureTextBottom";

//TeaserSectors_________________________________
const TeaserSectors = (props) => {
    return (
        <div className="TeaserSectors-Container">
            <CompHeadingText
                Title={"Entdecken Sie unsere maßgeschneiderten Lösungen für Ihre Branche"}
                Subheading={""}
            />
            <div className="TeaserSectors-Sectors">
                <CompPictureTextBottom
                    Graphic={ImgSector1}
                    GraphicAlt={"Lebensmittel & Bäckereien"}
                    Subheading={"Lebensmittel & Bäckereien"}
                    Link={"/bakery"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector2}
                    GraphicAlt={"Gastronomie"}
                    Subheading={"Gastronomie"}
                    Link={"/gastronomy"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector3}
                    GraphicAlt={"Gesundheitswesen"}
                    Subheading={"Gesundheitswesen"}
                    Link={"/healthcare"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector4}
                    GraphicAlt={"Großhandel"}
                    Subheading={"Großhandel"}
                    Link={"/wholesale"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector5}
                    GraphicAlt={"Apotheke"}
                    Subheading={"Apotheke"}
                    Link={"/pharmacies"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector6}
                    GraphicAlt={"Lebensmittelproduzenten"}
                    Subheading={"Lebensmittelproduzenten"}
                    Link={"/food-producers"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector7}
                    GraphicAlt={"Einzelhandel"}
                    Subheading={"Einzelhandel"}
                    Link={"/retail"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector8}
                    GraphicAlt={"Maschinen- und Anlagenbau"}
                    Subheading={"Maschinen- und Anlagenbau"}
                    Link={"/engineering"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector9}
                    GraphicAlt={"Postdienstleister"}
                    Subheading={"Postdienstleister"}
                    Link={"/postal-service"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector10}
                    GraphicAlt={"Transportlogistik"}
                    Subheading={"Transportlogistik"}
                    Link={"/transportation"}
                />
                <CompPictureTextBottom
                    Graphic={ImgSector11}
                    GraphicAlt={"Workwear"}
                    Subheading={"Workwear"}
                    Link={"/workwear"}
                />
            </div>
        </div>
    )
};
export default TeaserSectors;
